import * as React from "react";
import { ReactElement } from "react";
import AssessmentResultSummary from "./AssessmentResultSummary";
import UserCardMedium from "../commons/components/user/UserCardMedium";
import Report from "../commons/model/report/Report";
import UserInfo from "../commons/model/UserInfo";

interface AssessmentResultHeaderProps {
  report: Report;
  actions: ReactElement[];
  printMode?: boolean;
  patientFileUrl?: string;
  patientPortalAccountCreationUrl?: string;
}

export default function AssessmentResultHeader(props: AssessmentResultHeaderProps) {
  return (
    <div className="assessment-result-header">
      <div className="container h-flex">
        <div className="panel">
          <UserCardMedium
            user={props.report.subject as UserInfo}
            pageUrl={props.patientFileUrl}
            patientPortalAccountCreationUrl={props.patientPortalAccountCreationUrl}
          />
        </div>
        <AssessmentResultSummary
          report={props.report}
          actions={props.actions}
          printMode={props.printMode}
        />
      </div>
    </div>
  );
}
